import Vue from 'vue'
import Router  from 'vue-router'
import Login from '../views/Login.vue'
import SearchByTicket from '../views/Home/SearchByTicket.vue'
import DetailsTRX from '../views/Home/DetailsTRX'
import Reports from "@/views/Reports.vue"
import store from '@/store'

Vue.use(Router)

const router = new Router ({
  mode: 'hash',
  routes: [
    {
      path:"/",
      redirect:{
        name:"login"
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { disallowAuthed: true }
    },
 
    {
      path: '/details/:id/local/:local/fecha/:date/pos/:pos',
      name: 'Details',
      component: DetailsTRX,
      props:true,
       meta: {
        requiresAuthentication: true
      } 
    },
    {
      path: '/search-ticket',
      name: 'SearchByTicket',
      component: SearchByTicket,
      props:true,
       meta: {
        requiresAuthentication: true
      } 
    },
    {
      path: "/reports",
      component: Reports
    },
  ]
})
router.beforeEach((to, from, next) => {
  let isAuthenticated = store.getters['module/isAuthenticated']
  console.log(isAuthenticated)
  if (to.name !== 'login' && !isAuthenticated) next({ name: 'login' })
  else if (to.meta.disallowAuthed && isAuthenticated) next({ name: 'SearchByTicket' })
  else next()
})


export default router;